<style>
.input__wrapper input {
  width: 95%;
}
.input__wrapper input label {
  margin-right: 5px;
}
.input__wrapper {
  padding: 5px;
}
#addDictionaryModal .v--modal-box.v--modal {
  min-height: 250px !important;
  min-width: 450px !important;
}
#addDictionaryModal .v-text-field__slot input {
  font-size: 12px;
}
#addDictionaryModal button {
  float: right;
}
#description {
  padding-top: 10px;
}
#newSchemaInput,
#newTableInput {
  margin-left: 5px;
}
.btn--addDict {
  position: absolute;
  bottom: 10px;
  right: 20px;
}
</style>

<template>
  <Modal
    modalName="addDictionaryModal"
    title="DODAWANIE SŁOWNIKA"
    :buttons="['']"
  >
    <v-layout
      wrap
      align-start
    >
      <v-flex xs12>
        <p id="description">Proszę podać szczegóły nowego słownika. Wartości należy wprowadzić oddzielone przecinkami.</p>
      </v-flex>
      <v-flex xs6>
        <div class="input__wrapper">
          <v-text-field
            v-model="dictName"
            id="newNameInput"
            placeholder="Nazwa"
          ></v-text-field>
        </div>
        <div class="input__wrapper">
          <v-text-field
            v-model="dictValues"
            id="newValuesInput"
            placeholder="Wartości"
          ></v-text-field>
        </div>
        <div class="input__wrapper">
          <v-text-field
            v-model="dictColumn"
            id="newColumnInput"
            placeholder="Kolumna"
          ></v-text-field>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="input__wrapper">
          <v-text-field
            v-model="dictSchema"
            id="newSchemaInput"
            placeholder="Schemat"
          ></v-text-field>
        </div>
        <div class="input__wrapper">
          <v-text-field
            v-model="dictTable"
            id="newTableInput"
            placeholder="Tabela"
          ></v-text-field>
        </div>
      </v-flex>
    </v-layout>
    <span
      class="group pa-2 btn--addDict"
      title="Dodaj nowy słownik"
      @click="addDictionary"
    >
      <v-icon>check_circle</v-icon>
    </span>
  </Modal>
</template>

<script>
import Modal from "../../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    dictName: "",
    dictValues: "",
    dictColumn: "",
    dictSchema: "",
    dictTable: ""
  }),
  methods: {
    addDictionary() {
      let newDictList = [];
      for(let i of this.dictValues.toString().split(",")) {
        newDictList.push(i.trim());
      }

      let payload = [{
        description: this.dictName,
        references: [
          {
            field: this.dictColumn,
            schema: this.dictSchema,
            table: this.dictTable
          }
        ],
        values: newDictList
      }];
      console.log(' : payload', payload);
      this.$store.dispatch("addDict", payload).then(success => {
        if(success) {
          this.$modal.hide("addDictionaryModal");
          this.clearVars();
          this.$root.$emit(
            "showSnackbar",
            "success",
            "Pomyślnie dodano słownik"
          );
          this.$emit("updateDicts");
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas dodawania słownika wystąpił błąd"
          );
        }
      });
    },
    clearVars() {
      this.dictName = "";
      this.dictValues = "";
      this.dictColumn = "";
      this.dictSchema = "";
      this.dictTable = "";
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/viewer/settings/modals/dictionaries/AddDictionary.vue